import React from 'react';
import { Form, Formik } from 'formik';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import messages from '../../i18n/messages';
import { FORGET_PASSWORD_URL } from '../../Routes';
import { Link } from 'react-router-dom';
import { doLogin } from '../../actions/login';

import { notEmpty } from '../../components/share/utils';
import { Password } from '../../components';

const LoginSchema = Yup.object().shape({
  username: Yup.string().required(messages.input.required),
  password: Yup.string().required(messages.input.required),
});

const Index = ({ login, message }) => {
  const initialValues = { username: '', password: '' };
  const onSubmit = (values) => login(values);

  return (
    <div className='login'>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={LoginSchema}>
        {(props) => (
          <Form className='container' autoComplete='off'>
            <fieldset>
              <legend className='text-primary'>Đăng nhập</legend>
              {message ? <div className='text-danger'>{message}</div> : null}
              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form-group'>
                    <label htmlFor='username'>
                      Tên đăng nhập hoặc email <span className='text-danger'>*</span>
                    </label>
                    <input
                      id='username'
                      name='username'
                      type='text'
                      onChange={props.handleChange}
                      value={props.values.username}
                      required
                      className='form-control'
                    />
                  </div>
                  <div>
                    <Password name='password' required label='Mật khẩu' validate={notEmpty} />
                  </div>
                </div>
              </div>
              <button
                type='submit'
                className='btn btn-primary'
                disabled={!props.dirty || !props.isValid || props.isValidating || props.isSubmitting}
              >
                Đăng nhập
              </button>{' '}
              <Link to={FORGET_PASSWORD_URL}>Quên mật khẩu</Link>
            </fieldset>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => {
  let message = state?.auth?.message;
  return { message };
};

const mapDispatchToProps = { login: doLogin };

export default connect(mapStateToProps, mapDispatchToProps)(Index);
